import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { useGetOne } from "react-admin";
import LoanModificationLog from "../../loans/paymentDetail/LoanModificationLog";
import LoanPaymentList from "../../loans/paymentDetail/LoanPaymentList";
import LoanPaymentTab from "../../loans/paymentDetail/LoanPaymentTab";
import useNotify from "../../unit/useNotify";
import VerticalSpacer from "../../unit/VerticalSpacer";
import LoanActions from "../summary/LoanActions";
import LoanBaseDataAside from "../summary/LoanBaseDataAside";
import LoanStepsHeader from "../summary/LoanStepsHeader";

import LoanModifyIcon from "../../unit/svgIcon/LoanModifyIcon";
import LoanPaymentMadeIcon from "../../unit/svgIcon/LoanPaymentMadeIcon";
import LoanPaymentScheduleIcon from "../../unit/svgIcon/LoanPaymentScheduleIcon";
import ApplicationDocuments from "../summary/ApplicationDocuments";
import DocumentsIcon from "../../unit/svgIcon/DocumentsIcon";
import DescriptionIcon from "@mui/icons-material/Description";
import LoanModificationPaymentTab from "../../loans/paymentDetail/LoanModificationPaymentTab";

const MainContent = styled("main")({
  height: `calc(100vh - 292px)`,
  overflowY: "auto",
  backgroundColor: "#fff",
  width: "100%",
  maxWidth: "100%",
  minWidth: "100%",
  wordBreak: "break-word",
  overflowX: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
});

const HeaderContent = styled("header")({
  position: "sticky",
  top: 0,
  marginBottom: "10px",
  paddingLeft: "0px",
  paddingRight: "0px",
  width: "100%",
  height: "120px",
  backgroundColor: "#f8f9f9",
});

const FooterContent = styled("footer")({
  background: "#fff",
  position: "sticky",
  paddingTop: "16px",
  paddingLeft: "0px",
  bottom: 0,
  width: "100%",
  height: "60px",
  borderTop: "1px solid #ddd",
});

const LoanSummaryTabShowBody = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [showTabOne, setShowTabOne] = useState(true);
  const [showTabTwo, setShowTabTwo] = useState(false);
  const [showTabThree, setShowTabThree] = useState(false);
  const [showTabFour, setShowTabFour] = useState(false);
  const [showTabFive, setShowTabFive] = useState(false);
  const [showTabSix, setShowTabSix] = useState(false);
  const [showLeftAside, setShowLeftAside] = useState(true);

  const appId = props.appId;
  let appPayment = {};

  const [record, setRecord] = useState();
  if (appId == "" || appId == undefined || appId == null) {
    return <Typography>Loading Error, missing Application ID</Typography>;
  }
  const { data, isPending, error } = useGetOne("loans", { id: appId });

  useEffect(() => {
    setRecord(data);
  }, [appId, data]);

  if (error) {
    errorNotify("Error loading Loan " + error);
  }
  if (isPending) {
    return <Typography>Loan Loading</Typography>;
  }

  const handleShowTab = (tabnum: number) => {
    if (tabnum == 1 || tabnum == null) {
      setShowTabOne(true);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 2) {
      setShowTabOne(false);
      setShowTabTwo(true);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 3) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(true);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 4) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(true);
      setShowTabFive(false);
      setShowTabSix(false);
    } else if (tabnum == 5) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(true);
      setShowTabSix(false);
    } else if (tabnum == 6) {
      setShowTabOne(false);
      setShowTabTwo(false);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(false);
      setShowTabSix(true);
    }
  };

  const handleShowLeftAside = () => {
    setShowLeftAside(!showLeftAside);
  };
  if (!record || record?.code == 201) {
    return (
      <Typography
        sx={{
          mt: 5,
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "gray",
        }}
      >
        {record?.msg ||
          "Loan not found! Please confirm the loan application is created successfully."}
      </Typography>
    );
  }

  return (
    record && (
      <Grid
        container
        columnSpacing={1}
        sx={{ mb: 0 }}
        id={`loan-summary-tab-body-${appId}`}
      >
        <Grid
          item
          sx={{
            width: "300px",
            maxWidth: "300px",
            marginLeft: "0px",
            flexShrink: 0,
            mb: 0,
            pl: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <LoanBaseDataAside appId={appId} record={record} />
        </Grid>
        <Grid
          item
          xs
          sx={{
            minWidth: 0,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            ml: "10px",
            padding: 0,
            "&.MuiGrid-item": { paddingLeft: "0px !important" },
          }}
        >
          <Grid container sx={{ width: "100%" }}>
            <Grid
              item
              sx={{ width: "calc(100% - 55px)" }}
              id={`rightbody-loan-summary-${appId}`}
            >
              <Card sx={{ mt: 1, p: "10px", overflowY: "auto" }}>
                <HeaderContent id="headercontent-loan-summary">
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#f8f9f9",
                      height: "120px",
                      display: "block",
                      border: "1px solid #f8f9f9",
                      paddingTop: "25px",
                    }}
                  >
                    <LoanStepsHeader appId={appId} record={record} />
                  </Box>
                </HeaderContent>
                <MainContent id="maincontent-loan-summary">
                  {showTabOne ? (
                    <div
                      id="sectionOne"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <LoanPaymentList
                        appId={appId}
                        loanNum={record?.loan?.loanNum}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabTwo ? (
                    <div
                      id="sectionTwo"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <LoanPaymentTab appId={appId} />
                    </div>
                  ) : (
                    <></>
                  )}

                  {showTabFour ? (
                    <div
                      id="sectionFour"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <LoanModificationPaymentTab appId={appId} />
                    </div>
                  ) : (
                    <></>
                  )}
                  {showTabFive ? (
                    <div id="sectionFive">
                      <ApplicationDocuments
                        appId={appId}
                        step="All"
                        substep="All"
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* {showTabSix ? (
                    <div id="sectionSix">
                      <LoanPaymentSource appId={appId} />
                    </div>
                  ) : (
                    <></>
                  )} */}
                  <VerticalSpacer h={5} />
                </MainContent>
                <FooterContent id={"footercontent-loan-summary-" + appId}>
                  <LoanActions appId={appId} record={record} />
                </FooterContent>
              </Card>
            </Grid>
            <Grid
              item
              sx={{
                width: "50px",
                maxWidth: "50px",
                textAlign: "right",
                mt: 2,
              }}
              id={"rightaside-loan-summary-" + appId}
            >
              <Tooltip title="Payment Schedule" placement="left">
                <IconButton
                  onClick={() => handleShowTab(1)}
                  // title="Payment Schedule"
                  className={showTabOne ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-paymentschedule"
                >
                  {/* <LocalAtmIcon /> */}
                  <LoanPaymentScheduleIcon
                    color={showTabOne ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Payments Made" placement="left">
                <IconButton
                  onClick={() => handleShowTab(2)}
                  // title="Payments Made"
                  className={showTabTwo ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-paymentsmade"
                >
                  <LoanPaymentMadeIcon
                    color={showTabTwo ? "white" : "#1976d2"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reset Schedule" placement="left">
                <IconButton
                  onClick={() => handleShowTab(4)}
                  // title="Modifications Log"
                  className={showTabFour ? "iconactive" : "iconinactive"}
                  id="btn-show-tab-loanmodify"
                >
                  <LoanModifyIcon color={showTabFour ? "white" : "#1976d2"} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Application Documents" placement="left">
                <IconButton
                  onClick={() => handleShowTab(5)}
                  aria-label="Uploaded Documents"
                  className={showTabFive ? "iconactive" : "iconinactive"}
                >
                  {/* <DescriptionIcon color={showTabFive ? "white" : "#1976d2"} /> */}
                  <DescriptionIcon
                    style={{ color: showTabFive ? "white" : "#1976d2" }}
                  />
                </IconButton>
              </Tooltip>
              {/* <IconButton
                onClick={() => handleShowTab(6)}
                title="Payment Source"
                className={showTabSix ? "iconactive" : ""}
              >
                <Tooltip title="Payment Source" placement="left">
                  <LoanAccountsIcon />
                </Tooltip>
              </IconButton> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default LoanSummaryTabShowBody;
